import { createReducer, on } from '@ngrx/store';
import * as RecordStatusActions from '../actions/record-status.actions';

export const recordStatusFeatureKey = 'recordStatus';

export interface State {
  record: any;
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(RecordStatusActions.loadRecordStatus, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(RecordStatusActions.loadRecordStatusSuccess, (state, action) => ({
    record: action.data.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(RecordStatusActions.loadRecordStatusFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(RecordStatusActions.clearRecordStatusState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);

